import { loadStripe, Stripe, StripeElementLocale } from '@stripe/stripe-js'
import { config } from '@/conf'
import { XHR } from '@/utils/xhr'
import { localstore } from '@/utils/localstorage'

const trial_pricing_dev = {"gbp":90,"qar":400,"kzt":39900,"zar":2000,"ron":300,"clp":855,"nzd":150,"pln":400,"aed":299,"try":3035,"eur2":50,"nok":600,"thb":2000,"eur":50,"pen":500,"sar":300,"chf":50,"krw":950,"jpy":150,"aud":199,"sgd":90,"czk":1250,"dkk":375,"sek":600,"usd":99,"pkr":19900,"ars":50000,"uah":3900,"cop":520000,"egp":3300,"brl":600,"cad":199,"ils":300,"myr":300,"mxn":1900,"huf":20500}

const sub_pricing_dev = {"aed":19900,"sgd":3900,"dkk":26000,"clp":24150,"sar":12000,"nzd":7000,"ron":19900,"jpy":5500,"try":60200,"czk":72956,"brl":10600,"aud":7900,"uah":18900,"ars":390000,"myr":9400,"zar":49900,"ils":19900,"kzt":1199900,"krw":27000,"gbp":1990,"chf":4900,"cop":9750000,"sek":32900,"pkr":599900,"pln":14000,"thb":110200,"usd":3200,"qar":11500,"eur":1950,"egp":97400,"pen":7900,"cad":7900,"eur2":4999,"mxn":38000,"huf":1197000,"nok":45000}

class Checkout {
  spk!: string
  trial_pricing!: {[key: string]: number}
  sub_pricing!: {[key: string]: number}
  stripe!: Stripe

  
  // checkout initializer
  constructor () {
    // set pre-defined pricing (for dev)
    this.trial_pricing = trial_pricing_dev
    this.sub_pricing  = sub_pricing_dev
    this.spk = 'pk_live_51NkMmMIoKUvpYI4XEwSSjBacuNH2FX4sN7aGUqM7DHLfLSJNyekfdhVuG6HDHsPLVgYV8zv5BxNAA40jHdkPlYFB00b8AJmWFS'

    /*
    // remove euro if current currency is eu2
    const current_currency = localstore.get('currency')
    if (current_currency && current_currency === 'eur2') {
      delete currency_formats['eur']
      delete currency_formats['eur3']
    } else if (current_currency && current_currency === 'eur') {
      delete currency_formats['eur3']
      delete currency_formats['eur2']
    } else if (current_currency && current_currency === 'usd') {
      delete currency_formats['usd2']
      delete currency_formats['usd3']
    } else if (current_currency && current_currency === 'usd2') {
      delete currency_formats['usd']
      delete currency_formats['usd3']
    } else if (current_currency && current_currency === 'usd3') {
      delete currency_formats['usd']
      delete currency_formats['usd2']
    } else if (current_currency && current_currency === 'cad2') {
      delete currency_formats['cad']
    }else if (current_currency && current_currency === 'aud2') {
      delete currency_formats['aud']
    }
     */

    /*
    // init xhr
    const xhr = new XHR()
    // fetch stripe public key and pricing from server
    xhr.get('/stripe').then(r => {
      const resp_data = r.decode<StripeInfo>()
      if (!resp_data) { console.error('failed to get stripe info'); return }
      // set pub key
      this.spk = resp_data!.spk
      // set updated pricing
      // this.trial_pricing = resp_data!.trial_pricing
      // this.sub_pricing = resp_data!.sub_pricing

      // remove euro if current currency is eu2
      const current_currency = localstore.get('currency')
      if (current_currency && current_currency === 'eur2') {
        delete currency_formats['eur']
      }

    }).catch(e => {
      console.error("failed to get stripe public key")
    })

     */
  }

  // initializes stripe module
  init () {
    // @ts-ignore
    loadStripe(this.spk).then((stripe: Stripe) => {
      this.stripe = stripe
    })
  }

  // launch checkout process
  launch (props: CheckoutConfig) {
    if (!check_card()) {
      return false
    }

    // init stripe elements
    const elements = this.stripe.elements({
      clientSecret: props.token,
      locale: (config.lang.iso === 'latam' ? 'es-419' : config.lang.iso) as StripeElementLocale
    })

    // create and mount stripe element
    const payment_el = elements.create('payment', { terms: {card: 'never'} })
    payment_el.mount('#payment-element')

    // on payment element 'ready' event. element is rendered and mounted
    payment_el.on('ready', () => {
      // fire on_ready handler
      props.on_ready()

      // submit event listener
      const form = document.getElementById('payment-form')!
      form.addEventListener('submit', async (event) => {
        event.preventDefault()

        // fire on_busy handler
        props.on_busy(true)

        // confirm setup intent
        const { error } = await this.stripe.confirmPayment({
          elements, confirmParams: {
            return_url: checkout_complete_url(props.uid),
            // billing_details: {
            //  name: nameInput.value,
            // },
          }
        })

        // immediate error (invalid card data ect.)
        if (error) {
          // ******-----
          // console.log(error)
          // ------*****

          // card declined
          if (error.type == 'card_error') {
            // get card check num and increment
            let n = check_card_n(); n ++
            localstore.set('XNpD5J8X', n+'NpD5J8X')
          }
          // fire on_error handler
          props.on_error(error.message!)
          // fire on_busy handler
          props.on_busy(false)
        } else {
          // customer will be redirected to an intermediate site to authorize the payment,
          // then redirected to the `return_url`

          // fire on_busy handler
          props.on_busy(false)
        }
      })
    })

    // fire on_change event when user focus on element (to hide any previous errors)
    payment_el.on('focus', (event) => {
      props.on_change()
    })

    payment_el.on('change', (event) => {
      console.log('payment element change event', event)
    })

    return true
  }
}

// checks card status
const check_card = () => {
  const n = check_card_n()
  // error
  if (n === -1) {
    return false
  }
  // no data
  else if (n === 0) {
    return true
  }
  // limit reached
  else if (n > 1) {
    return false
  }
  return true
}
const check_card_n = () => {
  const data = localstore.get('XNpD5J8X')
  if (data) {
    const count = data.substring(0,1)
    const num = parseInt(count);
    if (!num) {
      console.error('check_card NaN')
      return -1
    }
    return num
  }
  return 0
}

// checkout configuration
interface CheckoutConfig {
  uid       : string
  token     : string
  on_ready  (): void
  on_busy   (_:boolean): void
  on_error  (_:string): void
  on_change (): void
}

// returns the url where the user is directed after completing checkout
const checkout_complete_url = (uid: string) : string => {
  // dev mode
  if (process.env.NODE_ENV === 'development') {
    console.log("checkout configured in dev mode [endpoint: http://127.0.0.1:4444]")
    return "http://127.0.0.1:4444/checkout?uid="+uid+"&lang="+config.lang.iso
  }

  // append user language iso2 code if the language is set in url (forced)
  if (config.lang.in_url) {
    // url with app domain name defined in config, user id and user language
    return "https://"+config.host+"/checkout?uid="+uid+"&lang="+config.lang.iso
  }

  // url with app domain name defined in config
  return "https://"+config.host+"/checkout?uid="+uid
}

// global checkout class
let checkout: Checkout
const InitCheckout = () => {
  checkout = new Checkout()
}

// stripe pub key and pricing
interface StripeInfo {
  spk           : string
  trial_pricing : {[key: string]: number}
  sub_pricing   : {[key: string]: number}
}

/*
  "brl": 10600,
  "pen": 7900,
  "ars": 390000,
  "clp": 16200,
  "egp": 62500,
  "try": 38500,
  "cop": 9750000,
  "mxn": 38000,
 */

// currency symbols
const currency_formats: {[key: string]: string} = {
  "eur": "€{n}",
  "eur2": "€{n}",
  "gbp": "£{n}",
  "krw": "₩{n}",
  "sar": "{n} SR",
  "aed": "{n}د.إ",
  "dkk": "{n} kr",
  "czk": "{n} Kč",
  "sek": "{n} kr",
  "huf": "{n} Ft",
  "jpy": "¥{n}",
  "usd": "${n}",
  // "usd2": "${n}",
  // "usd3": "${n}",
  "aud": "${n}",
 //  "aud2": "${n}",
  "sgd": "${n}",
  "ron": "{n} lei",
  "cad": "${n}",
  // "cad2": "${n}",
  "pln": "{n}zł",
  "nok": "{n} kr",
  "nzd": "${n}",
  "chf": "{n} Fr",
  "ils": "₪{n}",
  "qar": "QR {n}",
  "brl": "R${n}",
  "pen": "S/{n}",
  "ars": "$ {n}",
  "clp": "$ {n}",
  "egp": "£ {n}",
  "try": "₺{n}",
  "cop": "$ {n}",
  "mxn": "$ {n}",
  "uah": "₴{n}",
  "zar": "R{n}",
  "thb": "฿{n}",
  "myr": "RM{n}",
  "kzt": "₸{n}",
  "pkr": "₨{n}"
}

const no_cent = ['jpy', 'clp', 'krw']

const trial_price = () => {
  // get currency from session storage
  const currency = localstore.get('currency') || 'eur2'
  // get amount int
  let amount = checkout.trial_pricing[currency]
  if (!no_cent.includes(currency)) {
    amount = amount/100
  }
  // return formatted price
  return currency_formats[currency].replace('{n}', amount.toFixed(2))
}
const subscription_price = () => {
  // get currency from session storage
  const currency = localstore.get('currency') || 'eur2'
  // get amount int
  let amount = checkout.sub_pricing[currency]
  if (!no_cent.includes(currency)) {
    amount = amount/100
  }
  // return formatted price
  return currency_formats[currency].replace('{n}', amount.toFixed(2))
}

export { checkout, CheckoutConfig, InitCheckout, trial_price, subscription_price, currency_formats }
